import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  message: null
};

const extensionHandleSlice = createSlice({
  name: 'extensionHandleSlice',
  initialState,
  reducers: {
    setMessage: (state, action) => ({ ...state, message: action.payload })
  }
});

export const { setMessage } = extensionHandleSlice.actions;
export const useExtensionHandleSliceSelector = createSelectorFn(extensionHandleSlice);
export default extensionHandleSlice;
